var seedrandom = require('seedrandom');

var self = require('./shuffle-seed');

module.exports = self;